var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Label", { attrs: { for: "new-name-text" } }, [
        _vm._v(
          _vm._s(_vm.resource("IOFormatListViewModel_Name_DisplayName")) + " *"
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newName,
                expression: "newName"
              }
            ],
            staticClass: "form-control",
            attrs: { id: "new-name-text", name: "Name", type: "text" },
            domProps: { value: _vm.newName },
            on: {
              blur: function($event) {
                return _vm.$v.name.$touch()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.newName = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _vm.showError
            ? _c("required", { attrs: { fieldName: "Name" } })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("label", { attrs: { for: "new-import-checkbox" } }, [
        _vm._v(_vm._s(_vm.resource("IOFormatListViewModel_Import_DisplayName")))
      ]),
      _vm._v(" "),
      _c("dnx-checkbox", {
        attrs: { id: "new-import-checkbox" },
        model: {
          value: _vm.newImport,
          callback: function($$v) {
            _vm.newImport = $$v
          },
          expression: "newImport"
        }
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: "new-export-checkbox" } }, [
        _vm._v(_vm._s(_vm.resource("IOFormatListViewModel_Export_DisplayName")))
      ]),
      _vm._v(" "),
      _c("dnx-checkbox", {
        attrs: { id: "new-export-checkbox" },
        model: {
          value: _vm.newExport,
          callback: function($$v) {
            _vm.newExport = $$v
          },
          expression: "newExport"
        }
      }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }